<auth-layout title="Verify Your Email ID" type="SIGNUP"
    [subTitile]="'Please enter the 4-digit verification code that was sent to ' + myEmail + '. The code is valid for 3 minutes.'"
    sideImage="assets/latest/forgot.svg">



    <form [formGroup]="otpForm" style="position: relative;
    max-width: 226px;">
        <div class="otp">
            <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{length:4}">
            </ng-otp-input>

        </div>
        <div style="text-align: right;">
            <strong style="color: #c01e2f;">{{remainingTime}}</strong>
        </div>

        <div class="vca d-flex justify-content-between mt-3">
            <div>
                <span class="o-f" (click)="navigateToResetPassword()">Verify</span>
            </div>

            <div class="forcenter">
                <!-- <a class="res-otp" (click)="resendOtp()" *ngIf="isExpire">Resend OTP</a>
            <a class="res-otp" *ngIf="!isExpire" style="cursor:no-drop ;">Resend OTP</a> -->
                <a class="res-otp" (click)="resendOtp()" *ngIf="isExpire; else notExpired"
                    style="text-decoration: underline;">Resend OTP</a>
                <ng-template #notExpired><a style="color: gray; cursor: no-drop;text-decoration: underline;"
                        style="text-decoration: underline;">Resend OTP</a></ng-template>

                <!-- <p class="mt-10">{{time == '1.59' || time == '0.59' ? '' : time }}</p> -->
            </div>
        </div>

    </form>

</auth-layout>